module.exports = __webpack_public_path__ + "static/communication-1-f9f2dab9858b0a3f9fb363e11570baef.svg";